import { cx } from "class-variance-authority";
import React from "react";

const Panel: React.FC<any> = ({ children, className, ...props }) => {
  return (
    <div
      {...props}
      className={cx("bg-white rounded-[8px]", "ds-debug", className)}
    >
      {children}
    </div>
  );
};

export default Panel;
